import { render } from "./CaseOverview.vue?vue&type=template&id=51b8767e&scoped=true"
import script from "./CaseOverview.vue?vue&type=script&lang=js"
export * from "./CaseOverview.vue?vue&type=script&lang=js"

import "./CaseOverview.vue?vue&type=style&index=0&id=51b8767e&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b8767e"]])

export default __exports__